
const TrainingRequirementsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            Training Requirements
          </h2>
          
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed mb-12">
            <p>
              OSHA categorizes training into various types, including those required at onboarding and those mandated annually. You must ensure training for employees on all workplace hazards they may face, with specific training necessary for particular hazards. For example:
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-blue-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-blue-900 mb-4">
                Annual Training
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Your organization's annual training topics may include bloodborne pathogens, fire safety, respiratory protection, and lockout/tagout, to name a few.
              </p>
            </div>
            
            <div className="bg-green-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-green-900 mb-4">
                Periodic Training
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Some training courses are required at less than annual intervals. For example, Forklift training is required every three years. Forklift (or powered industrial truck) training includes formal instruction and a practical evaluation to verify the lift's safety operation. First Aid certifications must be renewed every three years, and CPR certifications every two years.
              </p>
            </div>
          </div>
          
          <div className="mt-8 text-lg text-gray-700 leading-relaxed">
            <p>
              For employees exposed to hazards for the first time, OSHA mandates specific training prior to the exposure and periodically after that. Because periodic is not a defined term, our team can assist you in navigating the appropriate frequency of other training courses to ensure compliance.
            </p>
          </div>
          
          <div className="text-center mt-8">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrainingRequirementsSection;